/** @format */
/// <reference="knockout">
(function (factory) {
  // Module systems magic dance.
  if (typeof require === "function" && typeof exports === "object" && typeof module === "object") {
    // CommonJS or Node: hard-coded dependency on "knockout"
    factory(require("knockout"));
  } else if (typeof define === "function" && define["amd"]) {
    // AMD anonymous module with hard-coded dependency on "knockout"
    define(["knockout"], factory);
  } else {
    // <script> tag: use the global `ko` object, attaching a `validation` property
    factory(ko);
  }
})(function (ko) {
  // this is the factory

  if (typeof ko === "undefined") {
    throw new Error("Knockout is required; please ensure it is loaded before loading this plug-in");
  }

  var maskBindingHandler = function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    var DEFAULT_NUMBER_MASK = "0#";

    var mask = ko.unwrap(valueAccessor());

    // Actually, does this make sense?
    // Wouldn't this interfere with Knockout's own input bindings?
    var boundValue = null;
    if (allBindings.has("textInput")) {
      boundValue = allBindings.get("textInput");
    }
    if (allBindings.has("value")) {
      boundValue = allBindings.get("value");
    }

    if (mask && boundValue && ko.isObservable(boundValue)) {
      var jqueryMaskOptions = {
        onChange: function (value) {
          // update the observable after the mask has changed the value, in
          // case knockout does not pick up the change to the DOM event, which
          // can happen if the input is entered too fast such as by holding down
          // a key
          boundValue(value);
          return true;
        },
        translation: {
          "*": {
            pattern: /[2-9]/,
          },
          // Allow the pattern to define an optional place for the digit `1`
          // Presumably, this is for phone numbers.
          Z: {
            pattern: /1/,
            optional: true,
          },
        },
        onInvalid: function (val, event, element, invalid, options) {
          if (bindingContext.$data.inputMaskValid 
              && ko.isObservable(bindingContext.$data.inputMaskValid)
              && mask
              && mask != DEFAULT_NUMBER_MASK
          ) {
            console.log("invalid")
            bindingContext.$data.inputMaskValid(false)
          }
        },
        onComplete: function (value) {
          if (bindingContext.$data.inputMaskValid && ko.isObservable(bindingContext.$data.inputMaskValid)) {
            bindingContext.$data.inputMaskValid(true)
          }
        }
      };

      if (mask != DEFAULT_NUMBER_MASK) {
        jqueryMaskOptions.placeholder = mask
      }

      jQuery(element).mask(mask, jqueryMaskOptions);
    }
  };

  ko.bindingHandlers.mask = {
    // update: maskBindingHandler,
    init: maskBindingHandler,
  };
});
